import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {EventSubscriptionGraphQL} from '../../graphql-fragments/events/__generated/EventSubscriptionGraphQL';
import {
  createEventbridgeSubscription,
  CreateEventbridgeSubscriptionArgs,
  updateEventSubscription,
  UpdateEventSubscriptionArgs,
} from './EventsDAO';

export async function create(data: CreateEventbridgeSubscriptionArgs): Promise<EventSubscriptionGraphQL> {
  const response = await createEventbridgeSubscription(data);
  writeFragmentsToCache(getFragmentWrapper('EventSubscription'), [response.eventSubscription]);
  return response.eventSubscription;
}

export async function update(
  eventSubscriptionId: string,
  data: UpdateEventSubscriptionArgs
): Promise<EventSubscriptionGraphQL> {
  const response = await updateEventSubscription(eventSubscriptionId, data);
  writeFragmentsToCache(getFragmentWrapper('EventSubscription'), [response.eventSubscription]);
  return response.eventSubscription;
}
